/**
 * Category Constants
 *
 * Central configuration for category landing pages.
 * These slugs must match the database category slugs.
 */

/** Valid category slugs for landing pages */
export const VALID_CATEGORY_SLUGS = [
  'automotriz',
  'decorativa',
  'industria',
  'spies-hecker',
  'standox',
  'max'
] as const

/** Type-safe category slug */
export type CategorySlug = typeof VALID_CATEGORY_SLUGS[number]

/** Check if a string is a valid category slug */
export function isValidCategorySlug(slug: string): slug is CategorySlug {
  return VALID_CATEGORY_SLUGS.includes(slug as CategorySlug)
}

/** Category metadata for static rendering and SEO */
export const CATEGORY_META: Record<CategorySlug, {
  name: string
  title: string
  description: string
  isPremium: boolean
  color: string
}> = {
  automotriz: {
    name: 'Automotriz',
    title: 'Repintado Automotriz',
    description: 'Productos de alta calidad para el repintado automotriz profesional',
    isPremium: false,
    color: '#E31837'
  },
  decorativa: {
    name: 'Decorativa',
    title: 'Pintura Decorativa',
    description: 'Soluciones completas para interiores, exteriores e impermeabilización',
    isPremium: false,
    color: '#4A90A4'
  },
  industria: {
    name: 'Industrial',
    title: 'Pintura Industrial',
    description: 'Recubrimientos industriales de alto rendimiento',
    isPremium: false,
    color: '#2D5A27'
  },
  'spies-hecker': {
    name: 'SPIES HECKER',
    title: 'SPIES HECKER',
    description: 'Sistema premium de repintado automotriz con tecnología alemana',
    isPremium: true,
    color: '#003366'
  },
  standox: {
    name: 'STANDOX',
    title: 'STANDOX',
    description: 'Tecnología avanzada en acabados automotrices',
    isPremium: true,
    color: '#8B0000'
  },
  max: {
    name: 'MAX',
    title: 'MAX',
    description: 'Línea profesional de productos automotrices',
    isPremium: true,
    color: '#FF6600'
  }
}

/** Get category display name from slug */
export function getCategoryName(slug: CategorySlug): string {
  return CATEGORY_META[slug]?.name ?? slug
}

/** Get category SEO title from slug */
export function getCategoryTitle(slug: CategorySlug): string {
  return CATEGORY_META[slug]?.title ?? slug
}

/** Check if category is premium brand */
export function isPremiumCategory(slug: CategorySlug): boolean {
  return CATEGORY_META[slug]?.isPremium ?? false
}

/** Premium brand slugs */
export const PREMIUM_CATEGORY_SLUGS = VALID_CATEGORY_SLUGS.filter(
  slug => CATEGORY_META[slug].isPremium
)

/** Standard (non-premium) category slugs */
export const STANDARD_CATEGORY_SLUGS = VALID_CATEGORY_SLUGS.filter(
  slug => !CATEGORY_META[slug].isPremium
)
